import React from 'react';
import { useIntl } from 'react-intl';
import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';
import { BaseModalProps } from '@/features/modal/types';

export const TimeoutBlockModal = ({ closeModal }: Pick<BaseModalProps, 'closeModal'>) => {
  const intl = useIntl();

  return (
    <ModalLayout close={closeModal}>
      <div className="flex flex-col items-center gap-4">
        <h1 className="text-center text-lg font-bold">
          {intl.formatMessage({ id: 'timeout-block.modal.title' })}
        </h1>
        <p className="text-center max-w-xs">
          {intl.formatMessage({ id: 'timeout-block.modal.body' })}
        </p>
        <Button
          text={intl.formatMessage({ id: 'timeout-block.modal.button' })}
          onClickHandler={() => closeModal()}
          btnType="primary"
        />
      </div>
    </ModalLayout>
  );
};
